import { TwilioBridgeDataDocInterface, BridgeStatus } from '../../dataStore/reducers/docs/types'

export default function (data: TwilioBridgeDataDocInterface['data']) {

  const valueEntries = Object.entries(data)
  let bridgeName

  for (const [key, bridge] of valueEntries) {

    switch (key) {

      case 'primaryPresenter':
        if (bridge.status === BridgeStatus.UP) bridgeName = bridge.name
        break
      case 'secondaryPresenter':
        if (bridge.status === BridgeStatus.UP && !bridgeName) bridgeName = bridge.name
        break
      default:
        break

    }

  }

  return bridgeName || null

}
